import { AxiosInstance } from '../../helpers/AxiosInstance';
import Config from '../../config';


const getTutorialStatusByUserId = (userId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/user/tutorial/${userId}`)
}

const updateTutorialStatusByUserId = (userId: string, tutorialName: string, tutorialStatus: boolean) => {
    return AxiosInstance.patch(`${Config.FALKON_CONNECT_API}/api/v1/user/tutorial/${userId}/${tutorialStatus}/${tutorialName}`)
}


export const TutorialService = {
    getTutorialStatusByUserId,
    updateTutorialStatusByUserId
};